import { ChangeDetectorRef, Component, Input } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { NgxSpinnerService } from 'ngx-spinner'
import { MessageChannelWrapper } from './message-channel-wrapper'
import {
  ChannelCommands,
  SbSChannelInitialisationData,
  SbSChannelMessage,
  SbSMessageHandler,
} from './sbs-message-handler'

const debug = false

@Component({
  selector: 'app-channel-messaging-wrapper',
  templateUrl: './channel-messaging-wrapper.component.html',
  styleUrls: ['./channel-messaging-wrapper.component.scss'],
})
export class ChannelMessagingWrapperComponent {
  private _plainClientUrl = ''
  sanitizedClientUrl: SafeResourceUrl
  channelReady = false

  private sbsMessageChannelWrapper = new MessageChannelWrapper<SbSChannelMessage>()
  private firstIFrameLoadedReceived = false

  @Input() initialisationData: SbSChannelInitialisationData | undefined | null
  @Input() sbsMessageHandler: SbSMessageHandler | undefined
  @Input() ignoreFirstIFrameLoad: boolean | undefined

  constructor(
    private readonly sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.sanitizedClientUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._plainClientUrl)
    this.spinner.show('iframeLoadingSpinner')
  }

  @Input() set clientUrl(value: string) {
    this._plainClientUrl = value
    this.sanitizedClientUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._plainClientUrl)
    if (debug) {
      console.log(`set clientUrl`, value)
    }
  }

  iframeLoaded() {
    if (debug) {
      console.log(`iframeLoaded `)
    }
    if (this.ignoreFirstIFrameLoad && !this.firstIFrameLoadedReceived) {
      this.firstIFrameLoadedReceived = true
      return
    }
    if (this._plainClientUrl) {
      if (!this.sbsMessageChannelWrapper.channelReady && !this.sbsMessageChannelWrapper.channelInProgress) {
        this.setupSbsMessageChannel()
      }
    } else {
      if (debug) {
        console.log(`no editor url`)
      }
    }
  }

  private setupSbsMessageChannel() {
    const iframe = document.querySelector('iframe')
    if (!iframe || !iframe.contentWindow) {
      if (debug) {
        console.log(`iframe(.contentWindow) not found`)
      }
      return
    }
    this.sbsMessageChannelWrapper.connect(
      iframe,
      this.getInitMessage(),
      (port: MessagePort) => {
        this.sbsMessageHandler!.setPort(port)
        this.channelReady = true
        this.changeDetectorRef.detectChanges()
      },
      (message: SbSChannelMessage) => {
        this.handleReceivedChannelMessage(message)
      },
    )
  }

  private getInitMessage(): SbSChannelMessage {
    return {
      command: ChannelCommands.init,
      message: this.initialisationData!,
    }
  }

  private handleReceivedChannelMessage(channelMessage: SbSChannelMessage) {
    this.sbsMessageHandler!.handleMessage(channelMessage)
    this.changeDetectorRef.detectChanges()
  }
}
